import React from 'react';
import { useTranslation } from 'react-i18next';
import { Merchants } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';
import { useData } from '@hooks/useData';

export function MerchantsPage() {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('merchants-component.metatags.title', { marketplace: allSettings?.data?.marketplaceName }),
        description: t('merchants-component.metatags.description', { marketplace: allSettings?.data?.marketplaceName }),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.merchants,
        index: true,
    });

    return (
        <FiltersProvider>
            <Merchants />
        </FiltersProvider>
    );
}
